import React from "react"

import Label from "../atoms/Label"
import Button from "../atoms/Button"

import Input from "../molecules/Input"
import Field from "../molecules/Field"

import Form from "../organisms/Form"
import Grid from "../organisms/Grid"
import Modal from "../organisms/Modal"

import ArrowIcon from "../../images/arrow-right-line-sm.svg"

class RsvpView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      scrollTop: false,
      showAttendeeList: true,
      showForm: false,
      title: "RSVP",
      subtitle: null,
      attendee: {
        node: {
          First_Name: "First Name",
          Last_name: "Last Name",
          Number_Invited_Guests___Wedding: 0,
        },
      },
    }

    this.handleAttendeeFormCancel = this.handleAttendeeFormCancel.bind(this)
    this.handleAttendeeFormClose = this.handleAttendeeFormClose.bind(this)
    this.resetScrollTop = this.resetScrollTop.bind(this)
  }

  renderForm() {
    const attendee = this.state.attendee.node
    return (
      <Form name="RSVP">
        <Grid type="rows">
          <input
            type="hidden"
            name="name"
            value={`${attendee.First_Name} ${attendee.Last_name}`}
          />
          <Field type="fieldset">
            <Label type="legend">Will you be attending?</Label>
            <Input
              type="radio"
              label="Yes"
              name="rsvp"
              value="yes"
              required="true"
            />
            <Input
              type="radio"
              label="No, with regrets"
              name="rsvp"
              value="no"
              required="true"
            />
          </Field>

          <Input
            label="How many will be in your party?"
            hint={`Your party may total up to ${
              attendee.Number_Invited_Guests___Wedding
            } ${
              attendee.Number_Invited_Guests___Wedding > 1 ? "people" : "person"
            }.`}
            max={`${attendee.Number_Invited_Guests___Wedding}`}
            min="1"
            name="guest_count"
            placeholder="0"
            type="number"
            required="true"
          />

          <Input
            type="textarea"
            label="Any dietary restrictions?"
            name="dietary"
          />

          <Grid type="tight columns">
            <span>
              <Button type="submit" kind="primary">
                RSVP
              </Button>
            </span>
            <span>
              <Button
                type="button"
                kind="secondary"
                onClick={this.handleAttendeeFormCancel}
              >
                Cancel
              </Button>
            </span>
          </Grid>
        </Grid>
      </Form>
    )
  }

  handleAttendeeSelect(attendee) {
    this.setState({
      scrollTop: true,
      showAttendeeList: false,
      showForm: true,
      title: "RSVP",
      subtitle: `${attendee.node.First_Name} ${attendee.node.Last_name}`,
      attendee,
    })
  }

  resetScrollTop() {
    this.setState({
      scrollTop: false,
    })
  }

  handleAttendeeFormCancel() {
    this.setState({
      scrollTop: true,
      showAttendeeList: true,
      showForm: false,
      subtitle: null,
      attendee: null,
    })
  }

  handleAttendeeFormClose() {
    this.handleAttendeeFormCancel()

    this.props.handleClose()
  }

  renderAttendeeList() {
    return (
      <Grid type="rows">
        <div>
          <p>
            <strong>Who?</strong>
            <br />
            Please select your group from the list below.
          </p>
        </div>

        <Grid type="cells">
          {this.props.attendees.map(person => {
            return (
              <Button
                key={person.node.id}
                kind="cell"
                onClick={() => {
                  this.handleAttendeeSelect(person)
                }}
              >
                <span>
                  {person.node.First_Name} {person.node.Last_name}
                </span>
                <ArrowIcon />
              </Button>
            )
          })}
        </Grid>
      </Grid>
    )
  }

  render() {
    return (
      <Modal
        title={this.state.title}
        subtitle={this.state.subtitle}
        show={this.props.show}
        handleClose={this.handleAttendeeFormClose}
        scrollTop={this.state.scrollTop}
        scrollTopCallback={this.resetScrollTop}
      >
        {this.state.showForm && this.renderForm()}
        {this.state.showAttendeeList && this.renderAttendeeList()}
      </Modal>
    )
  }
}

export default RsvpView
